import React from 'react'
import { Link } from 'gatsby'

import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const FeatureBox = props => {
    const { title, children } = props;
    return (
        <Box maxWidth={200} m={1} px={1} border={1} borderRadius={6} borderColor='#cccccc'>
            <Typography variant='h6' noWrap align='center'>{title}</Typography>
            <Divider variant='middle' />
            <Typography align='center'>
            {children}
            </Typography>
        </Box>
        );
}

const PriceBox = props => {
    const { title, price, children } = props;
    return (
        <Box maxWidth={200} mx={1} mb={1} px={1} border={1} borderRadius={6} borderColor='#cccccc'>
            <Typography variant='body1' noWrap align='center'>{title}</Typography>
            { (price) &&
                <Box display='flex' alignItems='baseline' justifyContent='center'>
                <Typography variant='h6'>${price} </Typography>
                <Typography variant='body1'>/mo </Typography>
                </Box>
            }
            <Box mb={1}><Divider variant='middle' /></Box>
            <Typography align='center' variant='body2' component='span' >
            {children}
            </Typography>
        </Box>
        );
}


const IndexPage = () => {

    const [value, setValue] = React.useState('Home');

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    return (
      <div style={{minHeight: '100vh', backgroundColor: '#eeeeee', textAlign: 'left' }} >
        <Toolbar style={{ justifyContent: 'space-between', alignItems: 'center',
            background: 'linear-gradient(to right,  #444464, #eeeeee)',
            boxShadow: '0 1px 20px #000000',
            borderRadius: '0 0 5px 5px'
        }}>
        <div>&nbsp;</div>
        <div style={{fontSize: '1.25rem', fontWeight: 'bold', color: '#FFFFFF',  textShadow: '2px 1px 3px #000033'}}>
            ceres e-commerce
        </div>

        <div style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
          <Button variant='outlined' size='small' ><Link to='/home'> Sign in</Link></Button>
        </div>
        </Toolbar>

      <div style={{ margin: `0 auto`, padding: `10px 1.0rem 1.45rem`, maxWidth: 960, color: `#000000` }} >

      <Paper elevation={5} style={{clear: 'both'}}>
      <Tabs value={value} onChange={handleChange} centered
        indicatorColor="primary" textColor="primary"
        aria-label="tabs for pricing and about us pages">
          <Tab label='Home' value='Home'/>
          <Tab label='Pricing' value='Pricing'/>
          <Tab label='About' value='About'/>
      </Tabs>

      { (value === 'Home') &&
          <>
          <Box ml={4} mb={4} mt={1}>
              <Typography align='center'>
              WernerDigital ceres software for ecommerce. Simple, fast, and affordable marketplace tools.
                <Button variant='contained' color='primary' size='small' ><Link to='/beta'><span style={{color: '#ffffff'}}> Beta program Sign up</span></Link></Button>
              </Typography>

          </Box>

          <Box ml={4} mb={4} display='flex' flexWrap='wrap' justifyContent='center'>
              <FeatureBox title='Automate'>Schedule reports and import data</FeatureBox>
              <FeatureBox title='Organize'> Organize and compare identical items across multiple sku and selling channels</FeatureBox>
              <FeatureBox title='Monitor'>  Watch active listings for changes in marketplaces, check prices and inventory levels, and more!</FeatureBox>
          </Box>
          </>
      }
      { (value === 'Pricing') &&
          <>
          <Box ml={2} mb={4} mt={1}>
              <Typography align='center'>
              Save money without sacrificing security or reliability with our modern cloud serverless software.
              </Typography>
          </Box>

          <Box mb={4} display='flex' flexWrap='wrap' justifyContent='center'>
              <Box display='flex' >
              <PriceBox title='Basic' price='9.95'>
                <Box mb={1} justifyContent='center'>
                  <Button variant='contained' color='primary' size='small' ><Link to='/beta'><small style={{color: 'white'}}> Beta Available</small></Link></Button>
                </Box>
                <ul>

                  <li>1 user</li>
                  <li>US marketplaces</li>
                  <li>dev tools</li>
                  <li>email support</li>
                </ul>
              </PriceBox>
              <PriceBox title='Pro' price='24.95'>
                <Box mb={1} justifyContent='center'>
                  <Button variant='contained' color='primary' size='small' ><Link to='/beta'><small style={{color: 'white'}}> Beta Available</small></Link></Button>
                </Box>
                <ul>
                  <li>10 users</li>
                  <li>all marketplaces</li>
                  <li>dev tools</li>
                  <li>email support</li>
                </ul>
              </PriceBox>
              </Box>

              <Box display='flex' >
              <PriceBox title='Enterprise' price='49.95'>
                <Box mb={1} justifyContent='center'>
                  <Button variant='outlined' color='primary' size='small' ><small> Coming Soon</small></Button>
                </Box>
                <ul>
                  <li>100+ Users</li>
                  <li>all marketplaces</li>
                  <li>dev tools</li>
                  <li>email support</li>
                  <li>phone support</li>
                </ul>
              </PriceBox>
              <PriceBox title='Custom' price='99.95'>
                <Box mb={1} justifyContent='center'>
                  <Button variant='contained' color='primary' size='small' onClick={() => { setValue('About'); }}><small style={{color: 'white'}}>Contact Us</small></Button>
                </Box>
                <ul>
                  <li>100+ Users</li>
                  <li>all marketplaces</li>
                  <li>dev tools</li>
                  <li>email support</li>
                  <li>phone support</li>
                  <li>setup</li>
                </ul>
              </PriceBox>
              </Box>
          </Box>
          </>
      }
      { (value === 'About') &&
          <>
          <Box mx={4} mb={4} mt={1}>
           <Typography variant='h6'>
             Werner Digital Technology, Inc
           </Typography>
            <Typography variant='body1' align='justify'>

               is committed to providing quality ecommerce solutions to our clients since 2013.
               We specialize in practical technology to enhance your current systems and procedures.
                For more information, please see our current
                &nbsp;<u><a href="https://www.werner-digital.com/terms">Terms&nbsp;of&nbsp;Service</a></u>
                  &nbsp;&nbsp;and
                &nbsp;<u><a href="https://www.werner-digital.com/privacy">Privacy&nbsp;Policy</a></u>
              </Typography>
          </Box>

            <Box display='flex' justifyContent='center'>
              <Box>
              <Typography variant='h6' align='left'>
              Email
              </Typography>
              <Typography variant='body1' align='left'>
                sales
                <br />support
                <br />beta
              </Typography>
              <Typography variant='body1' align='right'>
               @wernerdigital.com
              </Typography>
              </Box>

              <Box>
              <Typography variant='h6' align='right'>
              Contact
              </Typography>
              <Typography variant='body1' align='right'>
              <small>Werner Digital Technology, Inc
              <br />  484 East Carmel Dr # 151
              <br />  Carmel Indiana 46032 USA
              <br />  +1(872)888-7271
              </small>
              </Typography>
              </Box>

            </Box>
          </>
      }

      <br /><br />
      </Paper>
      </div>
      </div>
    );
}

export default IndexPage

